import * as React from "react";
import Svg, { Circle, G, Path } from "react-native-svg";
const TimeUpdateIcon = (props) => (
  <Svg
    width={100}
    height={100}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={50} cy={50} r={50} fill="#FF7A00" fillOpacity={0.05} />
    <G opacity={0.8}>
      <Path
        d="M81.8871 52.3458C81.7703 53.1632 81.6369 53.9639 81.5201 54.7812C80.7862 59.7354 78.9513 64.2559 76.0488 68.3094C71.3448 74.8816 65.0728 79.1686 57.1995 81.0869C54.8141 81.6707 52.3954 82.0043 49.9267 81.9043C48.544 80.5216 48.6551 71.8662 49.9267 70.5947C53.3295 70.4779 56.599 69.794 59.5849 68.1259C65.3397 64.9065 68.9094 60.0857 70.1605 53.5969C70.394 52.3959 70.4774 51.1782 70.5275 49.9438C70.5608 48.8762 71.3282 48.1089 72.3957 48.1089C74.9312 48.1089 77.4667 48.1089 80.0022 48.1089C80.9697 48.1089 81.5035 48.676 81.8704 49.4767C81.8871 50.4442 81.8871 51.395 81.8871 52.3458Z"
        fill="#FF7A00"
      />
      <Path
        d="M49.9433 70.5947C49.9433 74.3645 49.9433 78.1344 49.9433 81.9043C46.3069 81.9543 42.7872 81.3204 39.3843 80.1027C34.3968 78.3346 30.0931 75.4988 26.5068 71.5955C22.0863 66.8081 19.284 61.1867 18.3498 54.6978C16.982 45.0229 19.6509 36.5324 25.9062 29.1094C26.2732 28.6591 26.6736 28.242 27.0906 27.825C27.3074 27.6082 27.3241 27.458 27.1406 27.1911C26.7403 26.6574 26.3566 26.1236 25.9896 25.5564C25.189 24.272 26.023 22.6873 27.541 22.654C31.928 22.5539 36.3151 22.4538 40.7021 22.3704C41.9365 22.3537 42.6538 22.8708 42.8873 23.905C42.9707 24.272 42.8873 24.6056 42.7539 24.9392C41.1358 29.0928 39.5345 33.263 37.8831 37.4165C37.2826 38.9344 35.5478 39.1179 34.5469 37.8001C33.9297 36.9828 33.9297 36.9828 33.3292 37.8335C30.4768 41.7368 29.1423 46.1239 29.3759 50.928C29.7595 59.0849 34.8138 66.0408 42.2368 69.0767C44.7055 70.0775 47.2744 70.5446 49.9433 70.5947Z"
        fill="#FF7A00"
      />
    </G>
    <Path
      opacity={0.7}
      d="M72.9964 28.7925C72.9631 29.3096 72.7796 29.7767 72.3959 30.1603C70.6611 31.8951 68.943 33.6299 67.1915 35.3481C66.3908 36.1321 65.2565 36.1487 64.5059 35.3981C63.7386 34.6308 63.7386 33.4965 64.5559 32.6791C66.2574 30.9443 67.9922 29.2429 69.7103 27.5248C70.3108 26.9242 71.0281 26.7241 71.8121 27.0577C72.5794 27.3913 72.9297 27.9918 72.9964 28.7925Z"
      fill="#FF9330"
    />
    <Path
      opacity={0.6}
      d="M61.3532 32.3789C59.6685 32.3455 58.8511 30.8276 59.6018 29.4931C60.8028 27.3746 62.0372 25.2895 63.2382 23.1877C63.4717 22.8041 63.772 22.4871 64.189 22.3203C64.9396 22.0034 65.7236 22.1869 66.2908 22.8041C66.8579 23.4213 66.958 24.2053 66.5243 24.9893C65.7737 26.3237 64.9897 27.6582 64.2223 28.976C63.7386 29.81 63.2715 30.6274 62.7878 31.4447C62.4208 32.0786 61.8537 32.3789 61.3532 32.3789Z"
      fill="#FF9330"
    />
    <Path
      opacity={0.8}
      d="M67.542 38.4841C67.5754 38.0337 67.8423 37.4832 68.4261 37.1496C70.6113 35.8818 72.7965 34.5974 75.0151 33.363C75.9158 32.8626 76.9834 33.1962 77.5005 34.0636C78.0176 34.9477 77.7674 36.0153 76.8333 36.6158C76.0826 37.0995 75.2986 37.5166 74.5146 37.9669C73.1468 38.7509 71.7957 39.5683 70.4111 40.3356C69.0433 41.0863 67.5087 40.2022 67.542 38.4841Z"
      fill="#FF9330"
    />
    <Path
      opacity={0.5}
      d="M55.7483 30.1436C54.5139 30.1436 53.6465 29.0427 53.9634 27.7916C54.5806 25.3562 55.2478 22.9375 55.9318 20.5355C56.2153 19.518 57.2162 19.0009 58.167 19.2677C59.2179 19.568 59.7684 20.5021 59.4848 21.5864C58.8676 23.9717 58.217 26.3571 57.5665 28.7425C57.3163 29.6099 56.6157 30.127 55.7483 30.1436Z"
      fill="#FF9330"
    />
    <Path
      opacity={0.4}
      d="M49.7498 29.5588C48.5575 29.8783 47.4347 29.0394 47.417 27.7489C47.3829 25.2367 47.4014 22.7277 47.4403 20.2305C47.4508 19.1743 48.2837 18.4158 49.2712 18.4275C50.364 18.4455 51.1375 19.2053 51.1442 20.326C51.1654 22.7898 51.1544 25.2623 51.1434 27.7348C51.1262 28.6374 50.5833 29.3182 49.7498 29.5588Z"
      fill="#FF9330"
    />
    <Path
      opacity={0.8}
      d="M71.7288 46.0071C70.7279 46.0071 69.9273 45.3732 69.7938 44.5058C69.6437 43.5884 70.1608 42.6376 71.0616 42.3874C73.5303 41.7035 76.0158 41.0195 78.5179 40.4023C79.452 40.1688 80.3695 40.7693 80.653 41.6868C80.9366 42.5875 80.5196 43.6718 79.6021 43.9387C77.0833 44.6726 74.5312 45.3232 71.979 46.0071C71.8789 46.0238 71.7788 46.0071 71.7288 46.0071Z"
      fill="#FF9330"
    />
  </Svg>
);
export default TimeUpdateIcon;
